import { Routes } from '@angular/router';
import { RoleGuard } from '@/shared/guards/role.guard';
import { UserRoleAll } from '@/shared/models/user';

// CRAT-975 — children a Lister must NOT see (the bulk-edit table + collections management). The
// parent `inventory` route lets Listers into the tree; these re-restrict to non-Lister roles, so a
// Lister hitting them is redirected (by RoleGuard) to their search-products landing.
const nonListerData = { allowedRoles: UserRoleAll };

export const inventoryRoutes: Routes = [
  {
    path: '',
    canActivate: [RoleGuard],
    data: nonListerData,
    loadComponent: () => import('./inventory-page/inventory-page.component').then((m) => m.InventoryPageComponent),
  },
  {
    path: 'search-products',
    loadComponent: () =>
      import('./inventory-search-products-page/inventory-search-products-page.component').then(
        (m) => m.InventorySearchProductsPageComponent
      ),
  },
  {
    path: 'add-product',
    loadComponent: () =>
      import('./inventory-add-product-page/inventory-add-product-page.component').then(
        (m) => m.InventoryAddProductPageComponent
      ),
  },
  {
    path: 'items/:id',
    loadComponent: () =>
      import('./inventory-item-page/inventory-item-page.component').then((m) => m.InventoryItemPageComponent),
  },
  {
    path: 'collections',
    canActivate: [RoleGuard],
    data: nonListerData,
    loadComponent: () =>
      import('./collections/collections-list-page/collections-list-page.component').then(
        (m) => m.CollectionsListPageComponent
      ),
  },
  {
    path: 'collections/:id',
    canActivate: [RoleGuard],
    data: nonListerData,
    loadComponent: () =>
      import('./collections/collection-detail-page/collection-detail-page.component').then(
        (m) => m.CollectionDetailPageComponent
      ),
  },
  {
    path: 'suppliers',
    loadComponent: () =>
      import('./sources/sources-list-page/sources-list-page.component').then((m) => m.SourcesListPageComponent),
  },
  {
    path: 'suppliers/:id',
    loadComponent: () =>
      import('./sources/source-detail-page/source-detail-page.component').then((m) => m.SourceDetailPageComponent),
  },
  {
    path: 'reconciliation',
    loadComponent: () =>
      import('./inventory-reconciliation-page/inventory-reconciliation-page.component').then(
        (m) => m.InventoryReconciliationPageComponent
      ),
  },
];
